import Button from '@mui/material/Button';
import './CustomButton.css';

const CustomButton = ({ customeClass = '',disabled= false, children, ...props  }) => {
  return (
    <Button className={customeClass} {...props} disabled ={disabled}>
      {children}
    </Button>
  );
};

export default CustomButton;
